import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../pages/Home/Home";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import CancellationTerms from "../pages/CancellationTerms/CancellationTerms";
import NavBar from "../components/site/NavBar";
import SiteFooter from "../components/site/SiteFooter";
import Cursor from "../components/site/Cursor";
import Seo from "../components/site/Seo";
import NotFound from "../pages/NotFound/NotFound";
import { useTranslation } from "react-i18next";

function Router() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const behavior = reduced ? "auto" : "smooth";
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        window.setTimeout(() => el.scrollIntoView({ behavior, block: "start" }), 40);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <>
      <Seo />
      <a className="skip" href="#icerik">{t("nav.skip")}</a>
      <Cursor />
      <NavBar />
      <main id="icerik">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
          <Route path="/iptal-iade-sartlari" element={<CancellationTerms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <SiteFooter />
    </>
  );
}

export default Router;
